module.exports = __webpack_public_path__ + "static/media/image16.6e3b5206.png";